module.exports = __webpack_public_path__ + "img/no.ebbedc2c.svg";